import axios from 'axios';
import { getApiBaseUrl, getAuthHeaders } from '../utils/urlConfig';

const API_BASE = `${getApiBaseUrl()}/admin`;

const SettingsService = {
  async getAll() {
    const res = await axios.get(`${API_BASE}/settings`, { headers: getAuthHeaders() });
    return res.data;
  },

  async updateAll(settings) {
    const res = await axios.put(`${API_BASE}/settings`, { settings }, { headers: getAuthHeaders() });
    return res.data;
  },

  async listAdmins() {
    const res = await axios.get(`${API_BASE}/admins`, { headers: getAuthHeaders() });
    return res.data;
  },

  async createAdmin(data) {
    const res = await axios.post(`${API_BASE}/admins`, data, { headers: getAuthHeaders() });
    return res.data;
  },

  async updateAdmin(id, data) {
    const res = await axios.put(`${API_BASE}/admins/${id}`, data, { headers: getAuthHeaders() });
    return res.data;
  },

  async getHealthMetrics() {
    const res = await axios.get(`${getApiBaseUrl()}/health/metrics`, { headers: getAuthHeaders() });
    return res.data;
  },

  async getCredentials() {
    const res = await axios.get(`${API_BASE}/credentials`, { headers: getAuthHeaders() });
    return res.data;
  },

  async updateCredential(key, value) {
    const res = await axios.put(`${API_BASE}/credentials/${encodeURIComponent(key)}`, { value }, { headers: getAuthHeaders() });
    return res.data;
  },

  async deleteCredential(key) {
    const res = await axios.delete(`${API_BASE}/credentials/${encodeURIComponent(key)}`, { headers: getAuthHeaders() });
    return res.data;
  },

  async testConnection() {
    const res = await axios.post(`${API_BASE}/credentials/test-connection`, {}, { headers: getAuthHeaders() });
    return res.data;
  },
};

export default SettingsService;
